import React from 'react';
import Route from 'react-router/lib/Route';
import IndexRoute from 'react-router/lib/IndexRoute';
import PublicApp from './publicApp';
import SignUpContainer from './auth/signup/signUpContainer';
import ResetPassword from './auth/resetPassword/resetPassword';
import ResetPasswordPage from './auth/resetPassword/resetPasswordPage';
import SignOutContainer from './main/timeTracker/containers/SignOutContainer';
import InstagramAuthRedirect from './auth/instagramAuth';
import OAuth from './auth/oauth';
import AppSettingsRoutes from './flags/routes';
import * as hooks from './auth/routerHooks';
import { CommanderAppLogin } from '../modules/shared/auth/app-login';
import { LoginContainer } from '../modules/shared/auth/login';
import { CheckTwoFaOnLogin } from '../modules/shared/auth/two-fa/check-two-fa-on-login';
import { FbeLogin, FbeLoginRedirect } from '../modules/shared/auth/fbe-login';

export default store => (
  <Route component={PublicApp}>
    <Route path="/authorize/:service" name="oauth-authorize" component={OAuth} />
    <Route path="/login" name="login" component={LoginContainer} />
    <Route path="/fbe-login" name="fbe-login" component={FbeLogin} />
    <Route
      path="/fbe-login-redirect"
      name="fbe-login-redirect"
      component={FbeLoginRedirect}
      onEnter={hooks.requireAuthForFbeLogin(store)}
    />
    <Route path="/two-fa" name="login" component={CheckTwoFaOnLogin} />
    <Route path="/instagram-auth" name="instagram-auth" component={InstagramAuthRedirect} />
    <Route path="/sign-up" name="sign-up" component={SignUpContainer} onEnter={hooks.redirectAuth(store)} />
    <Route path="/sign-out" name="sign-out" component={SignOutContainer} />
    <Route path="/reset-password" name="reset-password">
      <IndexRoute component={ResetPassword} />
      <Route path=":token(/:isbarber)" name="reset-password.*" component={ResetPasswordPage} />
    </Route>
    <Route path="/app-login/:loginToken" name="app-login" component={CommanderAppLogin} />
    {AppSettingsRoutes()}
  </Route>
);
